import React from "react";
import { useLocation, useNavigate } from "react-router";
import { ArrivalDexie } from "../../../../../dexie/Arrival";
import { db } from "../../../../../dexie/db";
import Default, { useShip } from "../../../../layouts/DefaultCrew";
import Template from "../../../../templates/Crew/Arrival/Create/Confirm";
import { Form, LocationState } from "./types";
import { useGetLastFrontReport } from "../../../../../hooks/dexie/dexie";
import { mapToArrivalMutationVariables } from "../arrival.module";

type LocationForm = {
  form: Form;
};

const Confirm = (props: LocationState): React.ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();
  const location_form = location.state as LocationForm;

  const ship = useShip();
  if (!props.form && !location_form.form) {
    alert("Input value is not set.");
    navigate(-1);
  }

  const form = props.form || location_form.form;

  const onCreate = async () => {
    try {
      if (!ship?.ship_id) throw Error("Error! ship id is missing");

      const variables = mapToArrivalMutationVariables(form, ship?.ship_id);

      const newArrival: ArrivalDexie = {
        id: undefined,
        isDraft: false,
        isSend: false,
        data: variables,
      };

      db.arrival.add(newArrival, 1);
    } catch (error) {
      console.error(error);
      alert("Failed to create data.");
      return;
    }

    navigate("/arrival/create/complete");
  };
  const lastReport = useGetLastFrontReport();

  const onBack = () => {
    navigate(`/arrival/create`, { state: { form: form } });
  };

  return (
    <Default title="" selectedTitle={"Arrival"}>
      <Template
        form={location_form.form}
        onCreate={onCreate}
        onBack={onBack}
        lastReport={lastReport}
      />
    </Default>
  );
};

export default Confirm;
